import React from "react";
import { ToastContainer as BaseToastContainer } from "react-toastify";
import { createGlobalStyle } from "styled-components";
import { color, fontFamily, radius, shadow } from "../Theme";

// Toasts follow the brand tokens: surface card, soft shadow, 4 px status bar on the left.
const ToastStyle = createGlobalStyle`
  .Toastify .Toastify__toast {
    min-height: 56px;
    padding: 12px 16px;
    border-radius: ${radius("control")}px;
    background: ${color("surface")};
    color: ${color("text")};
    box-shadow: ${shadow("raised")};
    border-left: 4px solid ${color("primary")};
    font-family: ${fontFamily()};
    font-size: 14px;
    line-height: 20px;
  }
  .Toastify .Toastify__toast--success { border-left-color: ${color("success-text")}; }
  .Toastify .Toastify__toast--error { border-left-color: ${color("danger-text")}; }
  .Toastify .Toastify__toast--warning { border-left-color: ${color("warning-text")}; }
  .Toastify .Toastify__toast--info { border-left-color: ${color("primary")}; }
  .Toastify .Toastify__toast--success .Toastify__toast-icon svg { fill: ${color("success-text")}; }
  .Toastify .Toastify__toast--error .Toastify__toast-icon svg { fill: ${color("danger-text")}; }
  .Toastify .Toastify__toast--warning .Toastify__toast-icon svg { fill: ${color("warning-text")}; }
  .Toastify .Toastify__toast--info .Toastify__toast-icon svg { fill: ${color("primary")}; }
  .Toastify .Toastify__close-button { color: ${color("text-muted")}; opacity: 1; align-self: center; }
  .Toastify .Toastify__close-button:focus-visible,
  .Toastify .Toastify__toast:focus-visible { outline: 2px solid ${color("primary")}; outline-offset: 2px; }
  @media (prefers-reduced-motion: reduce) {
    .Toastify .Toastify__toast { animation-duration: 1ms !important; }
  }
  @media (max-width: 480px) {
    .Toastify .Toastify__toast-container { padding: 12px; }
    .Toastify .Toastify__toast { margin-bottom: 8px; }
  }
`;

export default function ToastContainer(props) {
  return (
    <>
      <ToastStyle />
      <BaseToastContainer {...props} />
    </>
  );
}
